import React, { type ReactNode, useMemo } from 'react'

import { FilterDataProvider } from 'app/common/ui-components/filter'
import type { Params } from 'app/dataTypes/OrgSettingsChanges.types'

import HistoryFilterParams from './HistoryFilterParams'
import type { FilterParams } from './FIlterParams.type'
import filterItems from './filterItems'

type Props = FilterParams & {
  children: (params: Params) => ReactNode,
}

const HistoryFilterProvider = ({ children, orgId, section }: Props) => {
  const params = useMemo(() => ({ orgId, section }), [orgId, section])

  return (
    <FilterDataProvider filters={filterItems} params={params}>
      <HistoryFilterParams orgId={orgId} section={section}>
        {(p) => children(p)}
      </HistoryFilterParams>
    </FilterDataProvider>
  )
}

export default HistoryFilterProvider
